module.exports = __webpack_public_path__ + "static/img/bg-fifa.9bdd115.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardTW/img/bg-fifa.png
// module id = jXVs
// module chunks = 1